import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faPlus, faEdit } from "@fortawesome/free-solid-svg-icons";
import { localUrl, baseUrl } from "../../config/baseUrl";
import Pagination from "../Pagination/Pagination";
import { toast } from "react-toastify";

export default function NewsList() {
  const [news, setNews] = useState([]);

  const [paginationDetails, setPaginationDetails] = useState({
    currentPage: 0,
    totalPages: 0,
    totalItems: 0,
  });
  const [pageNumber, setPageNumber] = useState(1);
  const [pageLimit, setPageLimit] = useState(20);
  const [totalPages, setTotalPages] = useState(3);

  useEffect(() => {
    fetchNews();
  }, [pageNumber]);

  const fetchNews = async () => {
    try {
      const res = await axios.get(
        // `${localUrl}/admin/news/list?page=${pageNumber}`,
        `${baseUrl}/admin/news/list?page=${pageNumber}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (res?.data.status) {
        setNews(res?.data.data || []);
        const pagination = res?.data.pagination || {};

        setPaginationDetails({
          currentPage: pagination.currentPage,
          totalPages: pagination.totalPages,
          totalItems: pagination.totalRecords,
        });
      }
    } catch (error) {
      console.error("Error fetching reports:", error);
    }
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(
        //   `${localUrl}/admin/news/delete/${id}`, 
          `${baseUrl}/admin/news/delete/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        fetchNews();
        Swal.fire("Deleted!", "News has been removed.", "success");
      } catch (error) {
        console.error("Error deleting report:", error);
        Swal.fire("Error!", "News could not be removed.", "error");
      }
    }
  };

  const handleStatus = async (id, newStatus) => {
    try {
      const res = await axios.patch(
        // `${localUrl}/admin/news/status/${id}`,
        `${baseUrl}/admin/users/status/${id}`,
        { status: newStatus },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (res?.data.status) {
        fetchNews();
        toast.success(res?.data.message || "Status updated");
      } else {
        toast.error("Failed to update status");
      }
    } catch (error) {
      console.error("Status update error:", error);
      toast.error("Failed to update status");
    }
  };

  const truncate = (str, max = 50) =>
    str && str.length > max ? str.slice(0, max) + "..." : str;
  return (
    <section className="main-sec">
      <div className="row">
        <div className="col-lg-6">
          <div className="dashboard-title">
            <h4 className="dash-head">
              <i className="fa fa-chart-bar me-2" />
              News List
            </h4>
          </div>
          <div className="custom-bredcump">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  News List
                </li>
              </ol>
            </nav>
          </div>
        </div>

        <div className="col-lg-6 d-flex justify-content-end align-items-start">
          <Link to="/news/add" className="btn btn-for-add text-white">
            <FontAwesomeIcon icon={faPlus} className="me-2" />
            Add News
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <div className="cards bus-list">
            <div className="bus-filter">
              <div className="row">
                <div className="col-lg-6">
                  <h5 className="card-title">
                    News List ({paginationDetails.totalItems || 0})
                  </h5>
                </div>
              </div>
            </div>

            <div className="table table-responsive custom-table">
              <table className="table table-borderless">
                <thead>
                  <tr>
                    <th>SN</th>
                    <th>Image</th>
                    <th>Title</th>
                    <th>Description</th>
                    <th>User Id</th>
                    <th>Total Count</th>
                    <th>Created At</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {news.map((item, i) => (
                    <tr key={item.id}>
                      <td>{i + 1}</td>
                      <td>
                        <img
                            // src={`${localUrl}/${item?.first_image}`}
                          src={`${baseUrl}/${item?.first_image}`}
                          alt="profile"
                          style={{ width: "60px" }}
                        />
                      </td>
                      <td>{truncate(item.title, 20) || "N/A"}</td>
                      <td>{truncate(item.description, 20) || "N/A"}</td>

                      <td>{item.user_id || "N/A"}</td>
                      <td>{item.total_count || "N/A"}</td>
                      <td>{item.created}</td>
                      <td>
                        <select
                          className="form-select"
                          value={item.status}
                          onChange={(e) =>
                            handleStatus(item?.id, e.target.value)
                          }
                          style={{
                            minWidth: "120px",
                            textTransform: "capitalize",
                          }}
                        >
                          <option value="Active">Active</option>
                          <option value="Inactive">Inactive</option>
                        </select>
                      </td>
                      <td>
                        <div className="action-buttons">
                          <Link
                            to={`/news/view/${item?.id}`}
                            className="action-btn edit-btn"
                          >
                            <i className="fa fa-eye"></i>
                            <span className="tooltip-text">View</span>
                          </Link>
                          <Link
                            to={`/news/edit/${item?.id}`}
                            className="action-btn edit-btn"
                          >
                            <i className="fa fa-edit"></i>
                            <span className="tooltip-text">Edit</span>
                          </Link>
                          <button
                            title="Delete"
                            className="btn btn-danger btn-sm"
                            onClick={() => handleDelete(item.id)}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                  {news.length === 0 && (
                    <tr>
                      <td colSpan="8" className="text-center">
                        No reports found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              {totalPages > 1 && (
                <Pagination
                  pageNumber={pageNumber}
                  setPageNumber={setPageNumber}
                  pageLimit={pageLimit}
                  paginationDetails={paginationDetails}
                  totalPages={paginationDetails.totalPages}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
